// @todo refactor types.ts to avoid circular imports (schema types must be exported in the actual schema files)
// https://demvsystems.atlassian.net/browse/VER-3811
export enum GENDER {
  MALE = 'maennlich',
  FEMALE = 'weiblich',
  UNKNOWN = 'unknown',
}
